__turbopack_context__.v({
  "className": "playfair_display_b3c75b38-module__5sbbCa__className",
  "variable": "playfair_display_b3c75b38-module__5sbbCa__variable",
});
